import React from 'react';
import { useTheme } from '@mui/material';

interface IProps {
  size: number;
  fill?: string;
}

export const FacebookIcon = ({ size, fill }: IProps) => {
  const theme = useTheme();
  return (
    <svg id="facebookicon__assets-icons-v2__svg__l12"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill ?? 'none'}
    stroke={theme.palette.common.white}
    strokeWidth={1}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-brand-facebook">
      
      <path id="facebookicon__assets-icons-v2__path__l24" stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path id="facebookicon__assets-icons-v2__path__l25" d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
    </svg>);

};